// extracted by mini-css-extract-plugin
export default {"title":"index-module__vFZez","form":"index-module__gyUGT","center":"index-module__qihRs"};